import React from 'react';
import styles from './TipBoxTop.module.scss';

/* Providers */
import { useShopContext } from '../../../../shared/__providers__/ShopContext';

/* Interfaces */

import { LockedPriceTag } from '../../LockedPriceTag/LockedPriceTag';
import {
  PaidTipProduct,
  PremiumTipProduct,
  TipProduct,
} from '../../../interfaces/TipProduct';

interface TipBoxTopProps {}

export const LockedTipBoxTop: React.FC<TipBoxTopProps> = () => {
  const { shop } = useShopContext();
  const tip = shop!.selectedProduct as TipProduct;

  return (
    <>
      {(tip as PaidTipProduct | PremiumTipProduct) && (
        <div className={styles.innerTopBox}>
          <LockedPriceTag />
        </div>
      )}
    </>
  );
};
